/**
 * @generated SignedSource<<6d232b4213429d6b0eb4611c9820890e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AssigneeDiscussionCardPaginationFragment_flowComments$data = {
  readonly flowComments: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly comment: {
          readonly commentText: string;
          readonly createdAt: Date | null | undefined;
          readonly gwtUser: {
            readonly fullName: string;
            readonly " $fragmentSpreads": FragmentRefs<"UserAvatar_gwtUser">;
          } | null | undefined;
          readonly rowId: UUID;
          readonly unread: boolean;
        } | null | undefined;
        readonly flow: {
          readonly name: string;
          readonly rowId: UUID;
          readonly " $fragmentSpreads": FragmentRefs<"FlowLink_flow">;
        } | null | undefined;
      };
    }>;
  } | null | undefined;
  readonly " $fragmentType": "AssigneeDiscussionCardPaginationFragment_flowComments";
};
export type AssigneeDiscussionCardPaginationFragment_flowComments$key = {
  readonly " $data"?: AssigneeDiscussionCardPaginationFragment_flowComments$data;
  readonly " $fragmentSpreads": FragmentRefs<"AssigneeDiscussionCardPaginationFragment_flowComments">;
};

import AssigneeDiscussionCardFlowCommentsPaginationQuery_graphql from './AssigneeDiscussionCardFlowCommentsPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "flowComments"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": AssigneeDiscussionCardFlowCommentsPaginationQuery_graphql
    }
  },
  "name": "AssigneeDiscussionCardPaginationFragment_flowComments",
  "selections": [
    {
      "alias": "flowComments",
      "args": [
        {
          "fields": [
            {
              "fields": [
                {
                  "fields": [
                    {
                      "kind": "Variable",
                      "name": "equalTo",
                      "variableName": "userId"
                    }
                  ],
                  "kind": "ObjectValue",
                  "name": "assignedToId"
                }
              ],
              "kind": "ObjectValue",
              "name": "flow"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        },
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": "UNREAD_COMMENTS_CREATED_AT_DESC"
        }
      ],
      "concreteType": "FlowCommentsConnection",
      "kind": "LinkedField",
      "name": "__AssigneeDiscussionCardPaginationFragment_flowComments_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FlowCommentsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "FlowComment",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Comment",
                  "kind": "LinkedField",
                  "name": "comment",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "unread",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "commentText",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "GwtUser",
                      "kind": "LinkedField",
                      "name": "gwtUser",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "fullName",
                          "storageKey": null
                        },
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "UserAvatar_gwtUser"
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Flow",
                  "kind": "LinkedField",
                  "name": "flow",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "FlowLink_flow"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "cf9a0a5772b37957574b4a64908f8a80";

export default node;
